import { AbstractSidebar } from "../../Sidebar/Abstract";

export abstract class Step extends AbstractSidebar {
    protected constructor(templateId: string, eventContinue: string, formWrapper: HTMLFormElement) {
        super(
            "template#vehicle-request-header",
            "template#vehicle-request-tabs",
            templateId,
            eventContinue,
            formWrapper
        );
    }

    public render(): void {
        setTimeout(super.render.bind(this), 0);
    }
}
